require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./squatters-in-foreclosed-home.json") })
        }
      }, "path---squatters-in-foreclosed-home");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---squatters-in-foreclosed-home!./.cache/json/squatters-in-foreclosed-home.json
// module id = 985
// module chunks = 231608221292675